<template>
    <div>
        <plan-table />
    </div>
</template>
<script>
import PlanTable from './components/table/index.vue'
export default {
  name: 'plan-planFabric',
  components: {
      PlanTable
  },
}
</script>